import { Link } from 'react-router-dom';

interface LinkGoToAdminProductProps {
  title: string;
  id: string;
  bold?: boolean;
  target?: string;
}

function LinkGoToAdminProduct({
  title,
  id,
  bold = false,
  target = '_self',
}: LinkGoToAdminProductProps): JSX.Element {
  return (
    <Link
      className="nimbus--link nimbus--link--primary nimbus--link--base"
      to={`/products/${id}`}
      target={target}
    >
      {bold ? <b>{title}</b> : title}
    </Link>
  );
}

export default LinkGoToAdminProduct;
